.dw{color:var(--gray-700);}